import React, { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import "../../../../../../styles/ambassadorChallenge/rewardDistribution.scss";
import gold from "../../../../../../assets/ambassador/gold.png";
import silver from "../../../../../../assets/ambassador/silver.png";
import bronze from "../../../../../../assets/ambassador/bronze.png";
import { isAuth } from "../../../../../auth/ProtectedRoute";
import { useAmbassadorChallengeContext } from "../../../../../../contexts/AmbassadorChallengeContext";

const Medal: React.FC<{ rank: number }> = ({ rank }) => {
  if (rank === 1) {
    return (
      <div className="medal medal-gold" aria-hidden>
        <img src={gold} alt="gold" />
      </div>
    );
  }
  if (rank === 2) {
    return (
      <div className="medal medal-silver" aria-hidden>
        <img src={silver} alt="silver" />
      </div>
    );
  }
  if (rank === 3) {
    return (
      <div className="medal medal-bronze" aria-hidden>
        <img src={bronze} alt="bronze" />
      </div>
    );
  }
  return <div className="medal medal-default">{rank}</div>;
};

const RewardRow: React.FC<RewardRowProps> = ({ item }) => {
  const { fetchReward } = useAmbassadorChallengeContext();
  

  const [sending, setSending] = useState(false);

  const distributeReward = async (distribution_id: number) => {
    try {
      setSending(true);
      const response = await axios.post(
        `${process.env.REACT_APP_HOST_API}ambassador/distribute-reward`,
        {
          distribution_id: distribution_id,
        },
        {
          headers: {
            Authorization: `Bearer ${isAuth()}`,
          },
        }
      );

      if (response.status === 200) {
        swal({
          title: response.data.message,
          text: `${response.data.data.amount} sent to ${item?.winner?.name}`,
          icon: "success",
        });

        fetchReward();
      }
    } catch (error: any) {
      if (error.response) {
        console.error("API Error:", error.response.data);
      } else {
        console.error("Network Error:", error.message);
      }
      throw error;
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="rd-row">
      <div className="col rank">
        <Medal rank={item.rank} />
      </div>

      <div className="col user">
        <div className="user-name">{item.winner?.name}</div>
        {/* <div className="user-ref">{item.winner.id}</div> */}
      </div>

      <div className="col points">{item.verified_referrals}</div>

      <div className="col reward">
        <span className="reward-amount">${item.reward_amount}</span>
      </div>

      <div className="col wallet">{item.winner?.id}</div>

      <div className="col distributed">{item.distributed_at ?? "-"}</div>

      <div className="col action">
        {sending ?
        <button
          className="distribute-btn"
          disabled={item.status === "distributed"}
        >
          Sending...
        </button>:

        <button
          className="distribute-btn"
          disabled={item.status === "distributed"}
          onClick={()=>{
            distributeReward(item?.id)
          }}
        >
          {item.status === "distributed" ? "Distributed" : "Distribute"}
        </button>}
      </div>
    </div>
  );
};

export default RewardRow;
